/*
 * DESIGN: Electric Motion — Main Page
 * Assembles all sections in order
 * Dark midnight theme throughout
 */

import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import WhySubscribe from "@/components/WhySubscribe";
import VehicleCatalogue from "@/components/VehicleCatalogue";
import HowItWorks from "@/components/HowItWorks";
import RateCalculator from "@/components/RateCalculator";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen" style={{ background: "oklch(0.09 0.015 250)" }}>
      <Navbar />
      <HeroSection />
      <WhySubscribe />
      <VehicleCatalogue featured={true} />
      <HowItWorks />
      <RateCalculator />
      <FAQSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
